import React, { useState, useEffect } from 'react'
import { Box } from '@mui/material'
import Menu from '../Menu/Menu'

const Footer = () => {
  return <Menu />
}
export default Footer
